import { render, staticRenderFns } from "./TabSonsMadrilla.vue?vue&type=template&id=b9faf346&scoped=true"
import script from "./TabSonsMadrilla.vue?vue&type=script&lang=js"
export * from "./TabSonsMadrilla.vue?vue&type=script&lang=js"
import style0 from "./TabSonsMadrilla.vue?vue&type=style&index=0&id=b9faf346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9faf346",
  null
  
)

export default component.exports